import { frontendURL } from '../../../helper/URLHelper';
import OnboardingShell from './Index.vue';
import KnowledgeBaseStep from './steps/KnowledgeBaseStep.vue';
import KnowledgeOptionsStep from './steps/KnowledgeOptionsStep.vue';
import SandboxStep from './steps/SandboxStep.vue';
import ChannelStep from './steps/ChannelStep.vue';
import PlanStep from './steps/PlanStep.vue';
import CompleteStep from './steps/CompleteStep.vue';

// Deliberately no subscriptionGuard here — onboarding is meant to run
// before any subscription exists (see getLoginRedirectURL in
// v3/helpers/AuthHelper.js and onboardingGuard's pricing_table handling in
// helper/onboardingRouteGuard.js, both of which route an account with
// incomplete milestones into this wizard regardless of entitlement status).
// Gating this route on subscriptionGuard would fight those redirects:
// subscriptionGuard bounces an inactive account to pricing_table,
// onboardingGuard bounces it right back here, forever.
export default {
  routes: [
    {
      path: frontendURL('accounts/:accountId/onboarding_shell'),
      name: 'onboarding_shell',
      component: OnboardingShell,
      meta: {
        permissions: ['administrator'],
      },
      redirect: { name: 'onboarding_welcome' },
      children: [
        {
          path: 'knowledge-base',
          name: 'onboarding_welcome',
          component: KnowledgeBaseStep,
          meta: {
            permissions: ['administrator'],
          },
        },
        {
          path: 'knowledge-base/options',
          name: 'onboarding_knowledge_options',
          component: KnowledgeOptionsStep,
          meta: {
            permissions: ['administrator'],
          },
        },
        {
          path: 'sandbox',
          name: 'onboarding_sandbox',
          component: SandboxStep,
          meta: {
            permissions: ['administrator'],
          },
        },
        {
          path: 'channel',
          name: 'onboarding_channel',
          component: ChannelStep,
          meta: {
            permissions: ['administrator'],
          },
        },
        {
          path: 'plan',
          name: 'onboarding_plan',
          component: PlanStep,
          meta: {
            permissions: ['administrator'],
          },
        },
        {
          path: 'complete',
          name: 'onboarding_complete',
          component: CompleteStep,
          meta: {
            permissions: ['administrator'],
          },
        },
      ],
    },
  ],
};
